import {Stroke} from '../../../../../../Models/Stroke';

export function selectRange(
    toBeFilteredStrokes: Stroke[],
    range: {
        min: number | null;
        max: number | null;
    },
    normalised: boolean,
) {
    const startTime = toBeFilteredStrokes[0].totalTime.milliseconds;
    if (normalised) {
        const normalisedRange = {
            min: range.min ? range.min / 100 : 0,
            max: range.max ? range.max / 100 : 1,
        };
        const endTime = toBeFilteredStrokes[toBeFilteredStrokes.length - 1].totalTime.milliseconds;
        const rangeTime = endTime - startTime;

        const minTime = normalisedRange.min * rangeTime;
        const maxTime = normalisedRange.max * rangeTime;

        return toBeFilteredStrokes.filter((stroke) => {
            return (
                stroke.totalTime.milliseconds - startTime <= maxTime &&
                stroke.totalTime.milliseconds - startTime >= minTime
            );
        });
    }

    return toBeFilteredStrokes.filter((stroke) => {
        if (
            range.min &&
            range.max &&
            stroke.totalTime.milliseconds - startTime <= range.min &&
            stroke.totalTime.milliseconds - startTime >= range.max
        ) {
            return false;
        }
        if (range.min && stroke.totalTime.milliseconds - startTime <= range.min) {
            return false;
        }
        if (range.max && stroke.totalTime.milliseconds - startTime >= range.max) {
            return false;
        }
        return true;
    });
}
